<template>
  <validation-observer ref="refFormObserver">
    <b-form slot-scope="{ validate }" @submit.prevent="validate().then(onSubmit)">
      <!-- Name -->
      <form-input
        label="Name"
        v-model="hsCodeFormData.name"
        :disabled="loading"
        name="Name"
        rules="required"
        placeholder="Enter HS code name"
      />

      <!-- Code -->
      <form-input
        label="Code"
        v-model="hsCodeFormData.code"
        :disabled="loading"
        name="Code"
        rules="required"
        placeholder="Enter HS code"
      />

      <!-- Description -->
      <form-text-area
        label="Description"
        v-model="hsCodeFormData.description"
        :disabled="loading"
        name="Description"
        placeholder="Enter description"
      />

      <!-- Is Active -->
      <b-form-group label="Status" class="mb-3">
        <b-form-checkbox
          id="hs-code-active"
          v-model="hsCodeFormData.isActive"
          name="hs-code-active"
          value="true"
          unchecked-value="false"
          :disabled="loading"
        >
          Active
        </b-form-checkbox>
      </b-form-group>

      <div class="d-flex justify-content-end">
        <b-button
          type="button"
          variant="outline-secondary"
          :disabled="loading"
          class="mr-1"
          @click="isModal ? $emit('cancel') : $router.go(-1)"
        >
          Cancel
        </b-button>
        <b-button type="submit" variant="primary" :disabled="loading">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          {{ loading ? 'Saving...' : 'Save HS Code' }}
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import { BForm, BFormGroup, BFormCheckbox, BButton, BSpinner } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { ref, computed, watch } from '@vue/composition-api';
import store from '@/store';
import { FormInput, FormTextArea } from '@/views/apps/fbr-invoice/components/form';

export default {
  name: 'HSCodeForm',
  components: {
    BForm,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BSpinner,

    // Form Validation
    ValidationObserver,
    ValidationProvider,

    // Custom Components
    FormInput,
    FormTextArea,
  },
  model: {
    prop: 'formData',
    event: 'update:form-data',
  },
  props: {
    formData: {
      type: Object | null,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const businessID = computed(() => store.state.user.businessID);

    const hsCodeFormData = ref(
      props.formData
        ? JSON.parse(JSON.stringify(props.formData))
        : {
            id: 0,
            name: '',
            code: '',
            description: '',
            isActive: true,
            businessID: businessID.value,
          }
    );

    const onSubmit = async () => {
      console.log('Emitting:', JSON.stringify(hsCodeFormData.value, null, 2));
      emit('submit');
    };

    watch(
      hsCodeFormData,
      (newVal) => {
        emit('update:form-data', newVal);
      },
      { deep: true }
    );

    return {
      hsCodeFormData,
      onSubmit,
    };
  },
};
</script>

<style lang="scss" scoped>
.b-card {
  margin-bottom: 1rem;
}
</style>
